import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const objetivoImporterSelectors = importerSelectors(
  'objetivo.importer',
);

export default objetivoImporterSelectors;
